import React from "react";
import { Row } from "react-bootstrap";
import { Routes, Route, useLocation } from "react-router-dom";
import { SettingsSidebar } from "./components"
import { SettingsPage } from "./SettingsPage";
import { AdminPage } from "./AdminPage";
import { TemplatesPage } from "./TemplatesPage";
import { FeedsPage } from "./FeedsPage";
import { AffiliatePage } from "./AffiliatePage";
import { BillingPage } from "./BillingPage";
import { SupportPage } from "./SupportPage";
import { FeedPage } from "./FeedPage";
import { FeedsAdminPage } from "./FeedsAdminPage";
import { FeedAdminPage } from "./FeedAdminPage";
import { TemplatePage } from "./TemplatePage";
import { NavigationHelper } from "../helpers";
import { CommissionCheckPage } from "./CommissionCheckPage";
import { AccountWarnings } from "../components/AccountWarnings";

export const SettingsRouter: React.FC = () => {
  const location = useLocation();

  React.useEffect(NavigationHelper.hideMobileSidebar, [location.pathname]) // eslint-disable-line


  return (
    <>
      <a href="about:blank" onClick={e => { e.preventDefault(); NavigationHelper.toggleMobileSidebar() }} className="d-md-none" id="sidebarToggle"><i className="fas fa-bars"></i></a>
      <Row>
        <nav className="col-sm-3 col-md-2 d-none d-md-block bg-dark sidebar" id="sidebar">
          <SettingsSidebar />
        </nav>
        <main role="main" className="col-sm-12 ml-sm-auto col-md-10 pt-3">
          <AccountWarnings />
          <Routes>
            <Route path="/affiliate/check/:id" element={<CommissionCheckPage />} />
            <Route path="/affiliate" element={<AffiliatePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/feeds/:id" element={<FeedPage />} />
            <Route path="/feeds" element={<FeedsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/templates/:id" element={<TemplatePage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/feedAdmin/:id" element={<FeedAdminPage />} />
            <Route path="/feedAdmin" element={<FeedsAdminPage />} />
            <Route path="/" element={<SettingsPage />} />
          </Routes>
        </main>
      </Row>
    </>
  );
};